export default __webpack_public_path__ + "static/media/guide@3x.b0bbee29.png";